import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import { MealCreditPage } from 'src/components/oneCorp/features/MealCredit/components/MealCreditPage';
import { MealCreditPaths } from 'src/components/oneCorp/features/MealCredit/components/Routes/MealCreditPathsDictionary';
import { MealCreditListRoute } from 'src/components/AppRoutes/MealCreditRoutes.layout';

export const MealCreditRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route
        exact
        path={MealCreditPaths.base}
        component={MealCreditListRoute}
      />
      <Route
        path={MealCreditPaths.base}
        render={(): ReactElement => <MealCreditPage />}
      />
    </Switch>
  );
};
